// Copyright (c) 2020 Sagacity Solutions Inc. All right reserved.
'use strict';

import langDictionary from './dictionary'

function BrowserDefaultLanguage() {
  return 'en';
  /*
  if (!window) return 'en';
  const browserLocale = window.navigator.userLanguage || window.navigator.language
  let locale = browserLocale ? browserLocale.substr(3, 4).toLowerCase() : null
  if (locale === '') locale = browserLocale.substr(0, 2).toLowerCase()
  return locale
  */
}

function Translate(key, lang) {
  let lookup = langDictionary && langDictionary[key];
  if (lookup !== undefined) {
    let r = lookup[lang] || key;
    return r;
  }
  return key;
}

function vuePhoneNumberInputTranslations(lang) {
  return {
    phoneNumberLabel: Translate('Phone number', lang),
    countrySelectorLabel: Translate('Country code', lang),
    countrySelectorError: Translate('Choose a Country', lang),
    example: Translate('Example :', lang),
  }
}

let languageList = [
        {value: 'en', text: 'English'},
        {value: 'es', text: 'Español'},
  ]

export {
  languageList,
  vuePhoneNumberInputTranslations,
  Translate,
  BrowserDefaultLanguage,
}
